
const accounts = {
    telecom: [
      {
        id: 20,
        accountCo: "Vodacom",
        accountStatus: "Default",
        balance: "1700",
        creditLimit: "0",
      },
    ],
    insurance: [
      {
        id: 21,
        accountCo: "MiWay",
        accountStatus: "Active",
        balance: "7000",
        creditLimit: "50000",
      },
    ],
    bond: [
      {
        id: 22,
        accountCo: "FNB",
        accountStatus: "Active",
        balance: "750000",
        creditLimit: "10000",
      },
    ],
    wifi: [
      {
        id: 23,
        industry: "Wifi",
        accountCo: "Telkom",
        accountStatus: "Active",
        balance: "2000",
        creditLimit: "0",
      },
    ],
  };
  
  export default accounts;